<template>
  <div>
    msg:{{test_name}}
  </div>
</template>
<script>
export default {
  name: "Wp_page_test",
  props: {
    test_name: { type: String, default: "tttt" },
    stype: { type: String, default: "tttt" }
  }
};
</script>